export const MenuList = [
    //Dashboard
    {
        title: 'Dashboard',	
        classsChange: 'mm-collapse',		
        iconStyle: <i className="material-symbols-outlined">home</i>,
        content: [
            {
                title: 'Dashboard Light',
                to: 'dashboard',					
            },
            {
                title: 'Dashboard Dark',
                to: 'dashboard-dark',
            },
            {
                title: 'School Profile',
                to: 'school-profile',
            },
            {
                title: 'Finance',
                to: 'finance',
            },
           
        ],
    },
    {
        title: 'Admin Cell',	
        classsChange: 'mm-collapse',		
        iconStyle: <i className="material-symbols-outlined">receipt</i>,
        content: [
            {
                title: 'Enrollment',
                to: 'enrollment',					
            },
            {
                title: 'Roll Assignment',
                to: 'roll-assignment',					
            },
            {
                title: 'Fee Structure',
                to: 'new-fee',					
            },
            {
                title: 'Manage Fees',
                to: 'fee-management',
            },
            {
                title: 'Tuition',
                to: 'tuition',
            },
            {
                title: 'Subjects',
                to: 'manage-subject',
            },
            {
                title: 'Assessment',
                to: 'assessment',
            },
            {
                title: 'Session',
                to: 'session',					
            },
            // {
            //     title: 'Class Management',
            //     to: 'manage-class',
            // },
            // {
            //     title: 'Exam Routine',
            //     to: 'exam-management',
            // },
           
        ],
    },
    {
        title: 'Certificates',	
        classsChange: 'mm-collapse',	
        iconStyle: <i className="material-symbols-outlined">verified</i>,
        content: [
            // {
            //     title: 'Course Completion',
            //     to: 'course-completion',					
            // },
            {
                title: 'Bonafide Certificate',
                to: 'bonafide-certificate',					
            },
            {
                title: 'Transfer Certificate',
                to: 'transfer-certificate',					
            }, 
            // { 
            //     title: 'Provisional Certificate',
            //     to: 'provisional-certificate',					
            // },           
        ],
    },
    {
        title: 'Student',	
        classsChange: 'mm-collapse',		
        iconStyle: <i className="material-symbols-outlined">school</i>,
        content: [
            {
                title: 'Student',
                to: 'student',					
            },
            {
                title: 'Attendance',
                to: 'attendance',					
            },
            // {
            //     title: 'Student Detail',
            //     to: 'student-detail',
            // },
            // {
            //     title: 'Add New Student',
            //     to: 'add-student',
            // },
            {
                title: 'Grading',
                to: 'grading',
            },
            {
                title: 'Transcript',
                to: 'transcript',
            },           
        ],
    },
    {
        title:'Teacher',
        classsChange: 'mm-collapse',		
        iconStyle: <i className="material-symbols-outlined">person</i>,
        content: [
            {
                title: 'Teacher',
                to: 'teacher',					
            },            
            {
                title: 'Add Teacher',
                to: 'add-teacher',					
            },
            {
                title: 'Pedagogic Tasks',
                to: 'pedagogic-tasks',					
            },
            // {
            //     title: 'Schedules',
            //     to: 'scheduled-classes',
            // },
        ],
    },
    {
        title:'Events & Activities',
        classsChange: 'mm-collapse',		
        iconStyle: <i className="material-symbols-outlined">edit_calendar</i>,
        content: [
            {
                title: 'Events',
                to: 'events',					
            },            
            {
                title: 'Manage Events',
                to: 'manage-events',					
            },
            {
                title: 'Event Calendar',
                to: 'event-calendar',					
            },
            {
                title: 'Notifications',
                to: 'notifications',					
            },
            {
                title: 'Volunteer',
                to: 'volunteer',					
            }
        ],
    },
    {
        title: 'File Manager',	
        classsChange: 'mm-collapse',		
        iconStyle: <i className="material-icons">folder</i>	,
        content: [
            // {
            //     title: 'File Manager',
            //     to: 'file-manager',					
            // },
            // {
            //     title: 'User',
            //     to: 'user',
            // },
            // {
            //     title: 'Calendar',
            //     to: 'calendar',
            // },            
            // {
            //     title: 'Chat',
            //     to: 'chat',
            // },
            // {
            //     title: 'Activity',
            //     to: 'activity',
            // },
            {
                title: 'Uploader',
                to: 'uploader',
            },
        ],
    },        
    //Apps
    {
        title: 'Apps (Disabled)',	
        classsChange: 'mm-collapse',
        iconStyle: <i className="material-icons">app_registration </i>,
        content: [
            // {
            //     title: 'Profile',
            //     to: 'app-profile'
            // },
            // {
            //     title: 'Edit Profile',
            //     to: 'edit-profile'
            // },
            // {
            //     title: 'Post Details',
            //     to: 'post-details'
            // },
            // {
            //     title: 'Email',
            //     //to: './',
            //     hasMenu : true,
            //     content: [
            //         {
            //             title: 'Compose',
            //             to: 'email-compose',
            //         },
            //         {
            //             title: 'Index',
            //             to: 'email-inbox',
            //         },
            //         {
            //             title: 'Read',
            //             to: 'email-read',
            //         }
            //     ],
            // },
            // {
            //     title:'Calendar',
            //     to: 'app-calender'
            // },
            // {
            //     title: 'Envoices',
            //     //to: './',
            //     hasMenu : true,
            //     content: [
            //         {
            //             title: 'Checkout',
            //             to: 'ecom-checkout',
            //         },
            //         {
            //             title: 'Invoice',
            //             to: 'ecom-invoice',
            //         },
            //         {
            //             title: 'Customers',
            //             to: 'ecom-customers',
            //         },
            //     ],
            // },
        ],
    },
    //Charts
    {
        title: 'Charts (Disabled)',	
        classsChange: 'mm-collapse',
        iconStyle: <i className="material-icons">assessment</i>,
        content: [
            
            // {
            //     title: 'RechartJs',
            //     to: 'chart-rechart',					
            // },
            // {
            //     title: 'Chartjs',
            //     to: 'chart-chartjs',					
            // },
            // {
            //     title: 'Sparkline',
            //     to: 'chart-sparkline',					
            // },
            // {
            //     title: 'Apexchart',
            //     to: 'chart-apexchart',					
            // },
        ]
    },
    //Boosttrap
    
    //plugins
    
   
    //Forms
    
    //Table
    {
        title:'Table (Disabled)',
        classsChange: 'mm-collapse',
        iconStyle: <i className="material-icons">table_chart</i>,
        content : [
            // {
            //     title:'Table Filtering',
            //     to: 'table-filtering',
            // },
            // {
            //     title:'Table Sorting',
            //     to: 'table-sorting',
            // },          
           

        ]
    },
    //Pages
    
    
]